import React, { useState, useEffect } from 'react';
import api from '../services/api'; // Corrigido o caminho do import para estar dentro do src
import './MainBanner.css'; // Criaremos este arquivo CSS depois

const MainBanner = () => {
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        setLoading(true);
        const response = await api.get('/banners.php'); // Usa a instância 'api' e o baseURL configurado
        // No backend, já ordenamos por ID DESC, então o mais recente vem primeiro.
        // Aqui, vamos filtrar para encontrar o primeiro banner ativo e dentro da data.
        const activeBanner = response.data.banners.find(b => {
          if (!b.is_active) return false;
          const now = new Date();
          const startDate = b.start_date ? new Date(b.start_date) : null;
          const endDate = b.end_date ? new Date(b.end_date) : null;

          if (startDate && startDate > now) return false; // Banner ainda não começou
          if (endDate && endDate < now) return false;   // Banner já expirou
          
          return true;
        });
        setBanner(activeBanner || null); // Define como null se nenhum banner ativo for encontrado
      } catch (err) {
        console.error('Erro ao buscar banner principal:', err);
        setError('Não foi possível carregar o banner.');
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  if (loading) {
    // Pode-se adicionar um skeleton loader aqui se desejar
    return <div className="main-banner-loading">Carregando banner...</div>;
  }

  if (error) {
    // Não renderizar nada em caso de erro para não quebrar o layout, apenas logar.
    console.error(error);
    return null;
  }

  if (!banner) {
    // Não renderizar nada se não houver banner ativo
    return null;
  }

  let imageUrl = `/uploads/banners/${banner.image_path.split('/').pop()}`;
  if (process.env.NODE_ENV === 'development') {
    imageUrl = `http://localhost:8080/catalogo${imageUrl.startsWith('/') ? imageUrl : '/' + imageUrl}`;
  }
        // As imagens dos banners são salvas com caminho relativo a 'uploads/banners/'
        // e o servidor web deve ser configurado para servir 'public_html/uploads' como '/uploads'

  return (
    <div className="main-banner-container">
      <a href={banner.link_url || '#'} target="_blank" rel="noopener noreferrer">
        <img src={imageUrl} alt={banner.title || 'Banner Promocional'} className="main-banner-image" />
      </a>
    </div>
  );
};

export default MainBanner;
